import { ChangeDetectionStrategy, Component, effect, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DataSummaryStore } from 'src/app/features/questionnaires/store/data-summary-store';
import { AnswersInDiagramComponent } from '../answers-in-diagram/answers-in-diagram.component';
import { AnswersInRowsComponent } from '../answers-in-rows/answers-in-rows.component';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { DataToolbarComponent } from '../data-toolbar/data-toolbar.component';
import { EQuestionType } from 'src/app/models/questionType.model';
import { AnswersInTableOrGroupComponent } from '../answers-in-table-or-group/answers-in-table-or-group.component';
import { NoResultComponent } from 'src/app/shared/components/no-result/no-result.component';
import { AnswersInRangeComponent } from '../answers-in-range/answers-in-range.component';
import { toSignal } from '@angular/core/rxjs-interop';


@Component({
    selector: 'que-summary',
    imports: [CommonModule, AnswersInDiagramComponent, AnswersInRowsComponent, AnswersInRangeComponent, NoResultComponent,
        AnswersInTableOrGroupComponent,
        TranslateDirective, TranslatePipe, DataToolbarComponent],
    templateUrl: './summary.component.html',
    styleUrls: ['./summary.component.scss']
})
export class SummaryComponent {
  #storeData = inject(DataSummaryStore);
  questionsData$ = toSignal(this.#storeData.questionsData$);
  isLoadedCurretStep$ = toSignal(this.#storeData.isLoadedCurretStep$);
  questionnarieParentDetails$ = this.#storeData.questionnarieParentDetails$;
  questionnarieDetails$ = this.#storeData.questionnarieDetails$;
  showComparison$ = this.#storeData.showComparison$;
  isDataForAllSig$ = this.#storeData.isDataForAllSig$;
  loadingData$ = toSignal(this.#storeData.loadingData$);
  // contacts$ = this.#storeData.contacts$;

  constructor() {
    this.#storeData.updateDisplayState("summary");
    effect(() => console.log('questionDara$', this.questionsData$()))
  }
  isDiagramType(type: number): boolean {
    var validTypes = [EQuestionType.Multi, EQuestionType.Autocomplete, EQuestionType.Mark]
    return validTypes.includes(type);
  }
  isRowsType(type: number): boolean {
    var validTypes = [EQuestionType.FreeText, EQuestionType.Fill, EQuestionType.PhoneNumber, EQuestionType.Number, EQuestionType.Date, EQuestionType.Signature]
    return validTypes.includes(type);
  }
  isTableType(type: number): boolean {
    var validTypes = [EQuestionType.Table, EQuestionType.QuestionsGroup];
    return validTypes.includes(type);
  }
  isRangeType(type: number) {
    return type == EQuestionType.Range;
  }
  // getValuesLength(values: any): number {
  //   return values ? Object.keys(values).length : 0;
  // }
  //     boolean=1,Multi,Autocomplete,Mark,FreeText,Number,Table=9,PhoneNumber,Range=12,Title,Text,Next,Send,Link,UploadFile,Fill,Divider
}
